const uniqueValues = arr => [...new Set(arr)]

export default uniqueValues
